import React from 'react';

const Header = ({ title }) => (
  <div className="mb-20 px-xl-0 px-3">
    <p className="heading__section text-uppercase">
      {title || 'Related guides and resources'}
    </p>
  </div>
);

export default Header;
